import React from 'react';

interface HouseholdMember {
  name: string;
  role: 'child' | 'adult';
}

interface Props {
  members: HouseholdMember[];
  onSelect: (name: string, role: 'child' | 'adult') => void;
  currentSpeaker?: string;
}

export const SpeakerPicker: React.FC<Props> = ({ members, onSelect, currentSpeaker }) => (
  <div className="flex flex-wrap gap-3 items-center">
    <span className="text-sm text-[#888888]">Speaking:</span>
    {members.map((m, i) => (
      <button
        key={i}
        onClick={() => onSelect(m.name, m.role)}
        className={`px-4 py-2 rounded-xl text-sm transition-colors ${
          currentSpeaker === m.name
            ? 'bg-[#111111] text-white'
            : 'bg-black/[0.05] text-[#3D3D3D] hover:bg-black/[0.08]'
        }`}
      >
        {m.name} ({m.role})
      </button>
    ))}
  </div>
);
